<template>
	<div style="width: 95%;margin: 0 auto;">
		<div
			style="width: 100%;height: 30px;border-left: 3px solid red;margin-top: 25px;font-size: 24px;font-weight: 800;padding-left: 25px;">
			任务项目管理
		</div>
		
		<div @click="isShow = !isShow" style="width: 200px;height: 30px;border: 1px solid #000;text-align: center;line-height: 30px;margin-top: 10px;">
			点击添加任务项目
		</div>

		<!-- <div style="width: 90%;margin-left: 3%;height: 40px;margin-top: 25px;box-shadow: #6e6e6e 0px 0px 10px;">
			<div @click="isShow = !isShow"
				style="width: 120px;height: 40px;font-weight: 800;text-align: center;line-height: 40px;font-size: 18px;margin-left: 20px;border: 1px solid #6e6e6e;box-sizing: border-box;">
				添加任务
			</div>
		</div> -->

		<div style="width: 100%;min-height: 300px;margin-top: 25px;">
			<div v-show="!isShow" style="height: 300px;">
				<div style="height: 100px;width: 100%;border-bottom: 1px dashed #6e6e6e;text-align: center;"
					v-for="(item,index) in neirong">
					<div style="width: 50%;height: 100px;float: left;">
						<div style="width: 70%;height: 50px;line-height: 50px;text-align: left;font-size: 20px;font-weight: 800;color: #000;float: left;overflow: hidden;
				text-overflow: ellipsis;
				white-space: nowrap;">
							{{item.title}}
						</div>
						<!-- <div v-show="item.status=='0'"
							style="width: 20%;height: 30px;margin-top: 10px;border: 1px solid orangered;float: left;line-height: 30px;">
							待审核
						</div>
						<div v-show="item.status=='1'"
							style="width: 20%;height: 30px;margin-top: 10px;border: 1px solid orangered;float: left;line-height: 30px;">
							待审核
						</div>
						<div v-show="item.status=='2'"
							style="width: 20%;height: 30px;margin-top: 10px;border: 1px solid orangered;float: left;line-height: 30px;">
							待审核
						</div> -->
						<div style="width: 100%;height: 50px;line-height: 60px;float: left;text-align: left;">
							<span class="el-icon-time"></span>
							<span>发布时间：</span>{{getLocalTime(item.create_time)}}
						</div>
					</div>
					<div style="width: 50%;height: 100px;float: left;position: relative;">
						<div @click="xiugaia(item)"
							style="width: 100px;height: 30px;line-height: 30px;position: absolute;top: 10px;right: 20px;border: 1px solid #6e6e6e;">
							修改
						</div>
						<router-link tag="div" :to="{ path:'/rwdtdetail',query:{id:item.id,title:item.title} }" style="width: 100px;height: 30px;line-height: 30px;position: absolute;top: 10px;right: 130px;border: 1px solid #6e6e6e;color: blue;">
							查看
						</router-link>
						<div @click="detela(item.id,item.mid)"
							style="width: 100px;height: 30px;line-height: 30px;position: absolute;bottom: 10px;right: 20px;border: 1px solid #6e6e6e;">
							删除
						</div>
					</div>
				</div>
			</div>
			<div v-show="isShow">
				<div style="width: 100%;height: 50px;">
					<div
						style="width: 20%;height: 50px;float: left;line-height: 50px;text-align: center;font-size:16px;">
						任务标题:
					</div>
					<el-input v-model="form.title" style="float: left;width: 70%;margin-top: 5px;"></el-input>
				</div>
				
				<div style="width: 100%;height: 550px;">
					<div
						style="width: 40%;height: 50px;float: left;line-height: 50px;text-align: center;font-size:16px;">
						简介 <span style="font-size: 12px;">上传图片大小控制再“600 x 350”之间)</span> :
					</div>
					<div style="float: left;width: 90%;margin-left: 5%;height: 500px;">
						<vue-tinymce v-model="form.content" :setting="setting" />
					</div>
				</div>

				<div style="width: 100%;height: 50px;">
					<div
						style="width: 20%;height: 50px;float: left;line-height: 50px;text-align: center;font-size:16px;">
						分类栏目:
					</div>
					<el-select v-model="form.fid" filterable placeholder="请选择" style="margin-top: 5px;">
						<el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
						</el-option>
					</el-select>
				</div>

				<div style="width: 100%;height: 50px;">
					<div
						style="width: 20%;height: 50px;float: left;line-height: 50px;text-align: center;font-size:16px;">
						任务图片:
					</div>
					<el-upload class="upload-demo" style="width: 200px;margin-top: 10px;height: 30px;float: left;"
						action="https://admin.shipoe360.com/api/picture/upload_pic" :on-preview="handlePreview"
						:on-remove="handleRemove" :before-remove="beforeRemove" :on-success="handsuccessss" :limit="1"
						:on-exceed="handleExceed" :file-list="fileListss">
						<el-button size="small" type="primary">点击上传</el-button>
					</el-upload>
				</div>

				<div style="width: 100%;height: 50px;margin-top: 25px;">
					<div
						style="width: 20%;height: 50px;float: left;line-height: 50px;text-align: center;font-size:16px;">
						任务费用:
					</div>
					<el-input v-model="form.price" style="float: left;width: 70%;margin-top: 5px;"></el-input>
				</div>

				<div style="width: 100%;height: 50px;">
					<div
						style="width: 20%;height: 50px;float: left;line-height: 50px;text-align: center;font-size:16px;">
						任务模型:
					</div>
					<el-select v-model="form.moxing" filterable placeholder="请选择" style="margin-top: 5px;">
						<el-option v-for="item in optionss" :key="item.value" :label="item.label" :value="item.value">
						</el-option>
					</el-select>
				</div>

				<div style="width: 100%;height: 50px;">
					<div
						style="width: 20%;height: 50px;float: left;line-height: 50px;text-align: center;font-size:16px;">
						赏金状态:
					</div>
					<el-select v-model="form.fid" filterable placeholder="请选择" style="margin-top: 5px;">
						<el-option v-for="item in optionssss" :key="item.value" :label="item.label" :value="item.value">
						</el-option>
					</el-select>
				</div>

				<div style="width: 100%;height: 50px;margin-top: 25px;">
					<div
						style="width: 20%;height: 50px;float: left;line-height: 50px;text-align: center;font-size:16px;">
						公布时间:
					</div>
					<el-input v-model="form.open_time" style="float: left;width: 70%;margin-top: 5px;"></el-input>
				</div>

				<div style="width: 100%;height: 50px;margin-top: 25px;">
					<div
						style="width: 20%;height: 50px;float: left;line-height: 50px;text-align: center;font-size:16px;">
						开始时间:
					</div>
					<el-date-picker v-model="form.begin_time" type="date" placeholder="选择日期" style="margin-top: 5px;">
					</el-date-picker>
				</div>

				<div style="width: 100%;height: 50px;margin-top: 25px;">
					<div
						style="width: 20%;height: 50px;float: left;line-height: 50px;text-align: center;font-size:16px;">
						结束时间:
					</div>
					<el-date-picker v-model="form.end_time" type="date" placeholder="选择日期" style="margin-top: 5px;">
					</el-date-picker>
				</div>

				<div style="height: 50px;width: 200px;margin: 0 auto;">
					<el-button type="primary" @click="onSubmit">立即创建</el-button>
					<el-button @click="isShow = !isShow">取消</el-button>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import http from "@/utils/http";
	export default {
		data() {
			return {
				isShow: false,
				setting: {
					menubar: false,
					toolbar: 'code undo redo restoredraft | cut copy paste pastetext | forecolor backcolor bold italic underline strikethrough link anchor | alignleft aligncenter alignright alignjustify outdent indent | \
					styleselect formatselect fontselect fontsizeselect | bullist numlist | blockquote subscript superscript removeformat | \
					table image media charmap emoticons hr pagebreak insertdatetime print preview | fullscreen | bdmap indent2em lineheight formatpainter axupimgs ltr rtl | emoticons help | wordcount',
					toolbar_drawer: "sliding",
					quickbars_selection_toolbar: "removeformat | bold italic underline strikethrough | fontsizeselect forecolor backcolor",
					plugins: "link image media table lists fullscreen quickbars advlist autosave directionality emoticons help imagetools pagebreak preview print wordcount",
					language: 'zh_CN', //本地化设置
					height: 500,
					selector: '#textarea1',
					automatic_uploads: false,
					images_upload_url: 'https://admin.shipoe360.com/ueditorphp/controller.php',
					fontsize_formats: '12px 14px 16px 18px 24px 36px 48px 56px 72px',
					font_formats: '微软雅黑=Microsoft YaHei,Helvetica Neue,PingFang SC,sans-serif;苹果苹方=PingFang SC,Microsoft YaHei,sans-serif;宋体=simsun,serif;仿宋体=FangSong,serif;黑体=SimHei,sans-serif;Arial=arial,helvetica,sans-serif;Arial Black=arial black,avant garde;Book Antiqua=book antiqua,palatino;',
				
				},
				form: {
					title: '', //任务标题
					fid: '', //分类栏目
					price: '', //价格
					moxing: '', //任务模型
					num: '', //竞标人数
					j_num: '', //任务编号
					open_time: '', //公布时间
					begin_time: '', //开始时间
					picurl: '', //任务封面图
					end_time: '', //结束时间
					content: `<p></p><p><br></p><ol></ol>`, // 富文本编辑器默认内容
				},
				fileListss: [],
				xsa: false,
				optionssss: [{
					value: '已托管赏金',
					label: '已托管赏金'
				}, {
					value: '已支付赏金',
					label: '已支付赏金'
				}, ],
				options: [{
					value: '1',
					label: '设计'
				}, {
					value: '2',
					label: '开发'
				}, {
					value: '3',
					label: '文案'
				}, {
					value: '4',
					label: '营销'
				}, {
					value: '5',
					label: '装修'
				}, {
					value: '6',
					label: '生活'
				}, {
					value: '7',
					label: '企业服务'
				}, ],
				optionss: [{
					value: '直接雇佣',
					label: '直接雇佣'
				}, {
					value: '雇佣任务',
					label: '雇佣任务'
				}, {
					value: '招标文件',
					label: '招标文件'
				}, {
					value: '计划任务',
					label: '计划任务'
				}, {
					value: '多人悬赏',
					label: '多人悬赏'
				}, {
					value: '单人悬赏',
					label: '单人悬赏'
				}, ],
				qid: '',
				neirong:'',
			}
		},
		mounted() {
			this.gotosb()
		},
		methods: {
			async onSubmit() {
				const loginInfo = JSON.parse(window.sessionStorage.getItem('user') || null)
				if (this.xsa == true) {
					let res = await http.post('api/Common/edit', {
						model: 'job',
						type: 'content',
						mid: '1',
						id: this.qid,
						title: this.form.title,
						picurl: this.form.picurl,
						moxing: this.form.moxing,
						content: this.form.content,
						num: this.form.num,
						j_num: this.form.j_num,
						open_time: this.form.open_time,
						begin_time: this.form.begin_time,
						end_time: this.form.end_time,
						uid: loginInfo.id
					})
					if (res.data.code == 200) {
						this.$notify({
							title: '成功',
							message: '上传成功',
							type: 'success'
						});
						this.gotosb()
						this.form.title = ''
						this.form.fid = ''
						this.form.price = ''
						this.form.moxing = ''
						this.form.num = ''
						this.form.j_num = ''
						this.form.open_time = ''
						this.form.begin_time = ''
						this.form.picurl = ''
						this.form.end_time = ''
						this.form.content = `<p></p><p><br></p><ol></ol>`
						this.fileListss = []
					}
				} else if (this.xsa == false) {
					let res1 = await http.post('api/Common/add', {
						model: 'job',
						type: 'content',
						mid: '1',
						fid: this.form.fid,
						title: this.form.title,
						picurl: this.form.picurl,
						content: this.form.content,
						price: this.form.price,
						moxing: this.form.moxing,
						num: this.form.num,
						j_num: this.form.j_num,
						open_time: this.form.open_time,
						begin_time: this.form.begin_time,
						end_time: this.form.end_time,
						uid: loginInfo.id
					})
					if (res1.data.code == 200) {
						this.$notify({
							title: '成功',
							message: '上传成功',
							type: 'success'
						});
						this.form.title = ''
						this.form.fid = ''
						this.form.price = ''
						this.form.moxing = ''
						this.form.num = ''
						this.form.j_num = ''
						this.form.open_time = ''
						this.form.begin_time = ''
						this.form.picurl = ''
						this.form.end_time = ''
						this.form.content = `<p></p><p><br></p><ol></ol>`
						this.fileListss = []
						this.gotosb()
					}
				}
			},
			handleRemove(file, fileList) {
				console.log(file, fileList);
			},
			xiugaia(item){
				console.log(item.fid)
				this.form.title = item.title,
				this.form.fid = this.options[item.fid - 1].value
				this.form.price = item.price
				this.form.moxing = item.moxing
				this.form.num = item.num
				 this.form.j_num = item.j_num
				 this.form.open_time = item.open_time
				 this.form.begin_time = item.begin_time
				 this.form.picurl = item.picurl
				 this.form.end_time = item.end_time
				 this.form.content = item.content
				 this.xsa = true
				 this.isShow = true
				 this.qid = item.id
			},
			async detela(val,vals){
				console.log(val,vals)
				const loginInfo = JSON.parse(window.sessionStorage.getItem('user') || null)
				let res = await http.post('api/Common/delete',{
					model: 'job',
					type: 'content',
					mid: '1',
					field_name: 'id',
					field_id: val,
					uid:loginInfo.id
				})
				if (res.data.code == 200) {
					this.$notify({
						title: '成功',
						message: '删除成功',
						type: 'success'
					});
					this.gotosb()
				}
			},
			getLocalTime(nS) {
				return new Date(parseInt(nS) * 1000).toLocaleString().replace(/:\d{1,2}$/, ' ');
			},
			async gotosb() {
				const loginInfo = JSON.parse(window.sessionStorage.getItem('user') || null)
				let res = await http.post('api/Common/index', {
					model: 'job',
					type: 'content',
					mid: '1',
					uid: loginInfo.id
				})
				this.neirong = res.data.data.list.data
			},
			beforeRemove(file, fileList) {
				return this.$confirm(`确定移除 ${ file.name }？`);
			},
			handsuccessss(response, file, fileList) {
				this.form.picurl = response.data.path
			},
			handleExceed(files, fileList) {
				this.$message.warning(`当前限制选择 1 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`);
			},
			handlePreview(file) {
				console.log(file);
			},
		}
	}
</script>

<style>
</style>
